import React, { useState, useEffect } from 'react';
import {
    Input,
    Form,
    Spin,
    message,
    Button,
    Row,
    Col,
    InputNumber,
    Collapse,
    Tooltip
} from "antd";
import _AdminService from 'modules/AdminService';
import moment from "moment";
import _utils from 'modules/Utils';
import _notification from 'modules/notification';
const { Panel } = Collapse;

const ViewCandidateInfo = (props) => {
    const [loading, setLoading] = useState(true);
    const [candidateData, setCandidateData] = useState([]);
    const { form } = props;

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                if (values.applicationId || values.rollNumber) {
                    setLoading(true);
                    let appId = values.applicationId || 0;
                    let rollNo = values.rollNumber || 0;

                    try {
                        const response = await _AdminService.GetStudentReceiptDataForAdmin(appId, rollNo);
                        console.log("response", response)
                        if (response.data.IsSuccess) {
                            setCandidateData(response.data.Obj);
                        } else {
                            if (response.data && response.data.Message) {
                                message.error(response.data.Message);
                            } else {
                                message.error("Something went wrong!");
                            }
                        }
                    } catch (error) {
                        message.error("Error fetching data.");
                    }
                    setLoading(false);
                } else {
                    message.error("Either Application ID or Roll Number is required!");
                }
            }
        });
    };

    const handleReset = () => {
        form.resetFields();
        setCandidateData([]);
    };

    const onApplicationIdChange = (value) => {
        form.setFieldsValue({ rollNumber: undefined });
        setCandidateData([]);
    };

    const onRollNumberChange = (value) => {
        form.setFieldsValue({ applicationId: undefined });
        setCandidateData([]);
    };

    return (
        <>
            <Spin size="large" spinning={loading}>
                {/* <div className='viewCardLabelAlign'>
                    <h5 className="mb10 f18 color-secondary">View Candidate Information</h5>
                </div> */}

                
                <div className="admin-container p-4">
                    <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto">
                        <h4 className="heading4 text-center">View Candidate Information</h4>
                        <Form
                                layout="vertical"
                                onSubmit={handleSubmit}
                            >
                            <div className="admin-inner-wrap p-3">
                                <Row gutter={16} align="middle">
                                    <Col xs={24} sm={10}>
                                        <Form.Item label="Application ID" hasFeedback>
                                            {form.getFieldDecorator('applicationId', {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    type="number"
                                                    min={0}
                                                    max={9999999999}
                                                    placeholder="Enter Application ID"
                                                    onChange={onApplicationIdChange}
                                                    style={{ width: '100%' }} // Full width input
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={4} style={{ textAlign: 'center', lineHeight: '32px' }}>
                                        <div className='orTxt'>OR</div>
                                    </Col>

                                    <Col xs={24} sm={10}>
                                        <Form.Item label="Roll Number" hasFeedback>
                                            {form.getFieldDecorator('rollNumber', {
                                                rules: [
                                                    {
                                                        required: false,
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    type="number"
                                                    min={0}
                                                    max={9999999999}
                                                    placeholder="Enter Roll Number"
                                                    onChange={onRollNumberChange}
                                                    style={{ width: '100%' }} // Full width input
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className="pt-4 text-center" >
                                <Button type="button" htmlType="submit" className="button-global button-primary autoHeight mr-4 small"><span>Submit</span></Button>
                                <Button type="button" onClick={handleReset} className="button-global button-secondary  autoHeight small"><span>Clear</span></Button>
                            </div>
                        </Form>                    
                    </div>
                </div>
    
                {candidateData && Object.keys(candidateData).length > 0 && (
                    <div className='mb-4'>
                        <div className="whiteBg gl-bxbr p-4 mb-4 max1200 m-auto cd-information">
                            <div className="admin-inner-wrap p-3">
                                <div className="collapse-container review_Data_Table">
                                    <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                            <Panel header="General Information" key="1">
                                                <table className='table_experience_review'>
                                                    <tbody>
                                                        <tr>
                                                            <th>Form No.</th>
                                                            <td style={{ color: 'red' }}>{candidateData.studentPersonalModel.Form_Number}</td>
                                                            <th>Application No.</th>
                                                            <td style={{ color: 'red' }}>{candidateData.studentPersonalModel.Application_Id}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Applied Post</th>
                                                            <td>{candidateData.studentPersonalModel.Applied_Post}</td>
                                                            <th>Password</th>
                                                            <td>
                                                                <Input.Password
                                                                    value={candidateData.studentPersonalModel.PasswordDecrypt}
                                                                    readOnly
                                                                    className="password-input"
                                                                /></td>
                                                        </tr>

                                                        <tr>
                                                            <th>Fees</th>
                                                            <td>{candidateData.studentPersonalModel.Exam_Fee}</td>
                                                            <th>Transaction Id</th>
                                                            <td>{candidateData.studentPersonalModel.Challan_Transaction_Id}</td>
                                                        </tr>

                                                        <tr>
                                                            <th>Form Submit Date</th>
                                                            <td>{(moment(candidateData.studentPersonalModel.Submitted_Date).isValid() ? moment(candidateData.studentPersonalModel.Submitted_Date).format("DD-MMM-YYYY h:mm:ss a") : 'N/A')}</td>
                                                            <th>Bank Transaction Id</th>
                                                            <td>{candidateData.studentPersonalModel.Submitted_Challan_Transaction_Id}</td>
                                                        </tr>

                                                        <tr>
                                                            <th>Application Status</th>
                                                            <td>{(candidateData.studentPersonalModel.Is_Submitted ? "Submitted" : "Not Submitted")}</td>
                                                            <th>Form Status</th>
                                                            <td style={{ fontWeight: "bold", color: 'green', backgroundColor: '#fffb04', marginLeft: '10px' }}>{candidateData.studentPersonalModel.Is_Approved_Rejected == 1 ? "Approved" : candidateData.studentPersonalModel.Is_Approved_Rejected == 2 ? "Rejected" : "Review Pending"}</td>
                                                        </tr>

                                                        <tr>
                                                            <th>Roll Number</th>
                                                            <td style={{ color: 'red' }}>{candidateData.studentPersonalModel.Roll_Number ? candidateData.studentPersonalModel.Roll_Number : "N/A"}</td>
                                                            <th>Aadhaar</th>
                                                            <td>
                                                                <Tooltip placement="right" title="Click to Download Aadhaar">
                                                                    <a className='downloadBtn' download="Aadhaar" href={candidateData.studentPersonalModel.Aadhar_Image_Path}>Download</a>
                                                                </Tooltip>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </Panel>
                                        </Collapse>

                                        <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                            <Panel header="Personal Information" key="1">
                                                <table className='table_100_percent tableHiddenBorder'>
                                                    <tbody>
                                                        <tr>
                                                            <td className='table_personal_info_review' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                                <table style={{ width: '100%' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Full Name</th>
                                                                            <td>{(candidateData.studentPersonalModel.First_Name) + ' ' +
                                                                                (candidateData.studentPersonalModel.Middle_Name) + ' ' +
                                                                                (candidateData.studentPersonalModel.Last_Name)}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Father's Name</th>
                                                                            <td>{candidateData.studentPersonalModel.Father_Name}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Mother's Name</th>
                                                                            <td>{candidateData.studentPersonalModel.Mother_Name}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Gender</th>
                                                                            <td>{candidateData.studentPersonalModel.Gender}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Date Of Birth</th>
                                                                            <td>{moment(candidateData.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Marital Status</th>
                                                                            <td>{candidateData.studentPersonalModel.Marital_Status}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Contact No.</th>
                                                                            <td><span>Mobile No. : </span>{candidateData.studentPersonalModel.Mobile_Number} <span className='ml5'> Email : </span>{candidateData.studentPersonalModel.Email}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Address</th>
                                                                            <td>
                                                                                <div>
                                                                                    {candidateData.studentPersonalModel.Address}
                                                                                </div>
                                                                                <span>Village/City : </span>{candidateData.studentPersonalModel.Village}, { }
                                                                                <span>Taluka : </span>{candidateData.studentPersonalModel.Taluka}, { }
                                                                                <span>Dist : </span>{candidateData.studentPersonalModel.District}, { }
                                                                                <span>Pin Code : </span>{candidateData.studentPersonalModel.Pin_Code}, { }
                                                                                <span>State : </span>{candidateData.studentPersonalModel.State} { }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Existing Employee</th>
                                                                            <td>{candidateData.Is_KaryalayinKamkaj == true ? "Yes" : "No"}</td>
                                                                        </tr>

                                                                        {candidateData.studentPersonalModel.IsDrivingLicenceMandatory && <tr style={{ height: '25px' }}>
                                                                            <th>Driving Licence No.</th>
                                                                            <td>{candidateData.studentPersonalModel.DrivingLicenceNumber}</td>
                                                                        </tr>}
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td style={{ borderStyle: 'hidden' }}>
                                                                <div>
                                                                    <div className='textAlignCenter'>
                                                                        <img className='receipt_details_profile_img' src={candidateData.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                                    </div>
                                                                    <div className='textAlignCenter'>
                                                                        <img className='receipt_details_signature_img' src={candidateData.studentPersonalModel.Signature_Path} alt="Signature" />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Panel>
                                        </Collapse>

                                        <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                            <Panel header="Reservation Details" key="1">
                                                <table className='table_reservation_review'>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <label style={{ marginRight: '7rem', display: 'inline', fontSize: '14px' }}><span>Category : </span>{candidateData.studentReservationModel.Category}</label>
                                                            </td>
                                                            <td>
                                                                <label style={{ marginRight: '7rem', display: 'inline', fontSize: '14px' }}><span>Caste : </span>{candidateData.studentReservationModel.Caste ? candidateData.studentReservationModel.Caste : "N/A"}</label>
                                                            </td>
                                                            <td colSpan={2}>
                                                                <label style={{ display: 'inline', fontSize: '14px' }}><span> Non Creamy Layer : </span>{(candidateData.studentReservationModel.Is_NonCreamyLayer_Available) === true ? 'Yes' : 'No'}</label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Physically Handicaped</th>
                                                            <td>{(candidateData.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                                            <th>Sports</th>
                                                            <td>{(candidateData.studentReservationModel.Is_Player) === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Earth Quake Affected</th>
                                                            <td>{(candidateData.studentReservationModel.Earth_Quake_Affected) === true ? 'Yes' : 'No'}</td>
                                                            <th>Anshkalin</th>
                                                            <td>{(candidateData.studentReservationModel.Is_Anshkalin) === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Ex Serviceman</th>
                                                            <td>{(candidateData.studentReservationModel.Ex_Serviceman) === true ? 'Yes' : 'No'}</td>
                                                            <th>Female</th>
                                                            <td>{(candidateData.studentReservationModel.Is_Ladies) === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Panel>
                                        </Collapse>

                                        <Collapse className="collapse-wrap mb-3" collapsible="header" defaultActiveKey={['1']}>
                                            <Panel header="Qualification Details" key="1">
                                                <table className='table_qualification_review mt-3'>
                                                    <tbody>
                                                        <tr>
                                                            <th>Education</th>
                                                            <th>Specialisation</th>
                                                            <th>Name of Board/University</th>
                                                            <th>Year Of Passing</th>
                                                            <th>Marks (%)</th>
                                                            <th>Class</th>
                                                        </tr>

                                                        {candidateData.studentQualificationDetailModels.map((item, index) => (

                                                            <tr data-index={index}>
                                                                <th>{item.Qualification}</th>
                                                                <td>{item.Qualification == "Other" ? item.Other_Information : item.Specilisation}</td>
                                                                <td>{item.University_Name}</td>
                                                                <td>{item.Passed_Year}</td>
                                                                <td>{item.Percentage_Grade}</td>
                                                                <td>{item.Class}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </Panel>
                                        </Collapse>


                                        <Collapse className="collapse-wrap" collapsible="header" defaultActiveKey={['1']}>
                                            <Panel header="Other Skills & Experience Details" key="1">
                                                <table className='table_experience_review'>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={2}>
                                                                <span>Typing Details</span>
                                                            </td>
                                                            <td colSpan={2}>
                                                                <span>Short Hand Details</span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Marathi Typing 30</th>
                                                            <td>{(candidateData.otherInformationModel.Is_Marathi_Typing_30) === true ? 'Yes' : 'No'}</td>
                                                            <th>100 Words/minutes</th>
                                                            <td>{(candidateData.otherInformationModel.Is_100_WPM) === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>English Typing 40</th>
                                                            <td>{(candidateData.otherInformationModel.Is_English_Typing_40) === true ? 'Yes' : 'No'}</td>
                                                            <th>120 Words/minutes</th>
                                                            <td>{(candidateData.otherInformationModel.Is_120_WPM) === true ? 'Yes' : 'No'}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4}>
                                                                <span>Experience Details</span>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th>Organization Name
                                                            </th>
                                                            <th>Designation
                                                            </th>
                                                            <th>From Date
                                                            </th>
                                                            <th>To Date
                                                            </th>
                                                        </tr>

                                                        {candidateData.otherInformationModel && candidateData.otherInformationModel.map((item, index) => (<>
                                                            <tr data-index={index}>
                                                                <td>{item.Organisation ? item.Organisation : "N/A"}</td>
                                                                <td>{item.Designation ? item.Designation : "N/A"}</td>
                                                                <td>{item && item.From_Date ? moment(item.From_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                                                <td>{item && item.To_Date ? moment(item.To_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                                            </tr>
                                                        </>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </Panel>
                                        </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>        
                )}
            </Spin>
        </>
    );
};

const styles = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '23vh'
    },
    contentContainer: {
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        width: '100%',
        textAlign: 'center',
        marginBottom: '10px',
        marginTop: '0px'
    },
    contentContainer1: {
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '870px',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0px'
    },
    tableHeader: {
        textAlign: 'left',
        padding: '8px',
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
        border: '1px solid #ddd'
    },
    tableData: {
        padding: '8px',
        border: '1px solid #ddd',
        textAlign: 'left',
    }
};

export default Form.create()(ViewCandidateInfo);